export default __webpack_public_path__ + "static/media/background_music.4c8a37b3.mp3";